import {
  Close,
  CloudUploadOutlined,
  ContentCopy,
  Delete,
  Edit,
} from "@mui/icons-material";
import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AudioVisualizer from "../lib/AudioVisualizer";
import { useSnackbar } from "notistack";
import FileUploaderModal from "../lib/FileUploaderModal";
import {
  AppendToContext,
  InsertRagContext,
  onboardingTemplate,
} from "../ClinicalNotesAPI/ClinicalNoteAPIManager";
import {
  acceptTNC,
  getDisclaimer,
  getTNC,
  sendNotification,
} from "../../../core/_request";
import DisclaimerModal from "../../modals/DisclaimerModal";
import AcceptCCOPDisclaimer from "../../modals/AcceptCCOPDisclaimer";
import Cookies from "js-cookie";
import { getSubDomain, getUsage, isAusDomain, updateUsageTracker } from "../lib/utils";
import dayjs from "dayjs";
import NewAudioVisualizer from "../lib/NewAudioVisualizer";
import sign from "jwt-encode";
import jwtDecode from "jwt-decode";
import { trackClinicalNoteCreation, trackClinicalNoteClickSendTranscription, trackClinicalNoteAcceptCaution } from "../../../../utils/analytics";

function NewTranscriptionDialog({ open, handleClose, onSuccess, data, setSubscriptionModal, responseData, clientDetails, setAppointmentIDfromAPI, setNoteDetails, patientData, isCreate }) {
  const [text, setText] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [state, setState] = useState("editor");
  const [loading, setLoading] = useState(false);
  const [disclaimercontent, setDisclaimercontent] = useState("");
  const [tncDialog, setTncDialog] = useState(false);
  const [disclaimer, setDisclaimer] = useState(false);
  const [pendingAppendData, setPendingAppendData] = useState(null);
  const fileRef = useRef(null);
  const resetTranscriptionStatusRef = useRef(null);

  const [historyList, setHistoryList] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [selectedTranscription, setSelectedTranscription] = useState(null);
  const [transcriptionLink, setTranscriptionLink] = useState([]);
  const [apiUsed, setApiUsed] = useState(null);
  const copyContent = () => {
    navigator.clipboard.writeText(text);
    enqueueSnackbar("Text copied!", {
      variant: "success",
    });
  };

  let tabTemplates = [];
  useEffect(() => {
    HandleDisclaimerFromAPI();
  }, []);

  const showProcessingSnackbar = () => {
    enqueueSnackbar("Please wait while we process your transcript...", { variant: "info" });
  }
  const handleSendData = async () => {
    setLoading(true);

    if (isCreate) {
      try {
        const profileData = JSON.parse(localStorage.getItem("profile")); // Parse profileData if it's stored as a string

        const cred = sign(
          { user_id: `${profileData?.UserId}` },
          process.env.REACT_APP_JWT_ENCODE_SECRET || ""
        );
        // Usage limits apply to all users (like AUS system)
        const usage = await getUsage("clinical_notes", profileData?.UserId, cred)
        if (!usage.success) return
        if (!usage?.data?.value) {
          setSubscriptionModal()
          return
        }

        const storedData = localStorage.getItem("Authorization");
        const token = storedData ? storedData.split("Bearer ")[1] : null;
        const expertId = String(profileData?.UserId);
        const expertType = String(profileData?.UserType);
        const userId = String(responseData?.user_id || patientData?.user_id);
        //console.log("response data", responseData)
        // setTranscriptionDialog(true);
        const payload = sign(
          {
            client: {
              user_id: userId,
              name: responseData?.name || clientDetails?.name || patientData?.name,
              email: responseData?.email || clientDetails?.email || patientData?.email,
              phone: responseData?.phone || clientDetails?.phone || patientData?.phone || "",
              his_number: responseData?.his_number || clientDetails?.his_number || patientData?.his_number || "",
              image: responseData?.image || clientDetails?.image || patientData?.image || "",
            },
            session_type: "Follow-up",
            session_date: dayjs().format("YYYY-MM-DD"),
            expert: {
              user_id: expertId,
              name: profileData?.Name,
              email: profileData?.Emailid,
              phone: profileData?.MobileNo,
              image: profileData?.ProfileImage,
              expert_type: expertType,
            },
          },
          process.env.REACT_APP_JWT_SECRET
        );
        // console.log("payload", payload)

        const body = JSON.stringify({ data: payload });

        console.log("1. CREATING CLINICAL NOTE ::: ", body)

        const response = await fetch(
          `${process.env.REACT_APP_EXPERT_BASE_URL}jwt-clinicalnotes/create`,
          {
            method: "POST",
            headers: {
              "X-API-Key": process.env.REACT_APP_EXPERT_API_KEY,
              "Content-Type": "application/json",
              Token: token,
              authenticationToken: Cookies.get("authDataJwt"),
            },
            body: body, // Serialize body object to JSON
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        if (response.status === 201) {
          const jsonData = await response.json();
          // Original code with domain check (commented out)
          // if (isAusDomain()) {
          //   const updateUsage = await updateUsageTracker("clinical_notes", profileData?.UserId, cred)
          // }

          // New code for all users
          const updateUsage = await updateUsageTracker("clinical_notes", profileData?.UserId, cred)

          // Track clinical note creation event - send immediately before any navigation
          await trackClinicalNoteCreation(profileData?.UserId);

          // setCreateNewClient(false);
          // setOpen(false);
          const newData = jwtDecode(jsonData?.data || jsonData);
          if (patientData) {
            setAppointmentIDfromAPI(newData?._id);
          }
          setNoteDetails(newData);
          // // setNoteType(newData?.session_type)
          // // setClinicalNotesState({ view: "view" });
          data = newData

          // Track newly created note in sessionStorage for save and exit tracking
          if (isCreate === true && newData?._id) {
            try {
              const newlyCreatedNotes = JSON.parse(sessionStorage.getItem('newlyCreatedClinicalNotes') || '[]');
              if (!newlyCreatedNotes.includes(String(newData._id))) {
                newlyCreatedNotes.push(String(newData._id));
                sessionStorage.setItem('newlyCreatedClinicalNotes', JSON.stringify(newlyCreatedNotes));
              }
            } catch (error) {
              console.error("Error storing newly created note ID:", error);
            }
          }

          // Track clinical note click send transcription event (only when creating new note)
          if (newData?._id) {
            try {
              await trackClinicalNoteClickSendTranscription(
                profileData?.UserId,
                newData._id
              );
            } catch (trackingError) {
              console.error("Error tracking click send transcription event:", trackingError);
              // Don't block process if tracking fails
            }
          }

          // Comment out navigation to open modal instead
          // const newURL = `/clinical/home?view=view&clinicalId=${newData?._id}&noteType=${newData?.session_type}`;
          // navigate(newURL);

        }

      } catch (error) {
        console.log("Error creating clinical note:", error);
      }
    }

    console.log("2. CREATED CLINICAL NOTE ::: ", data)

    if(data){
      try{
        // Determine model based on which API was used
        const model = apiUsed === "fetchSTTShunyaSecond" ? "med-en" : "whisper";
        
        // Handle transcriptionLink as array or single value for backward compatibility
        const linksArray = Array.isArray(transcriptionLink) ? transcriptionLink : (transcriptionLink ? [transcriptionLink] : []);
        
        const transcriptionHistoryBody = {
          note_id: `${data?._id}`,
          transcription_data: [
            {
              transcript: text,
              created_at: dayjs().format("YYYY-MM-DDTHH:mm:ss.SSS"),
              updated_at: dayjs().format("YYYY-MM-DDTHH:mm:ss.SSS"),
              link: linksArray.length > 0 ? linksArray : null, // Store array of links
              model: model,
            }
          ]
        }
        console.log("3. CREATING TRANSCRIPTION HISTORY ::: ", transcriptionHistoryBody)
        const transcriptionHistoryResponse = await fetch(`https://cauth.unitedwecare.com/transcriptions/create`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_STELLAAPIKEY,
          },
          body: JSON.stringify(transcriptionHistoryBody),
        });
        console.log("4. CREATED TRANSCRIPTION HISTORY ::: ", transcriptionHistoryResponse)
        if (!transcriptionHistoryResponse.ok) {
          throw new Error("Network response was not ok");
        }
        const transcriptionHistoryData = await transcriptionHistoryResponse.json();
        console.log("transcriptionHistoryData", transcriptionHistoryData);
      }catch(error){
        console.error("Error creating transcription history:", error);
      }
    }

    //console.log("::::::   ", data)
    console.log("5. INSERTING RAG CONTEXT ::: ", data)
    InsertRagContext({
      transcript: text,
      session_id: `${data?._id}`,
      appointment_id: `${data?._id}`,
      user_id: `${data?.client?.user_id}`,
      expert_id: `${data?.expert?.user_id}`,
      appointment_date: `${data?.session_date}`,
      booking_date: `${data?.session_date}`,
    }).then((res) => {
      if (res?.error) {
        enqueueSnackbar(res?.message, { variant: "info" });
        setLoading(false);
        return;
      }
      uploadRawText(text);

      // Process the transcript without artificial delay
      const processTranscript = async (retryCount = 0, maxRetries = 3) => {
        const dropdownData = [
          "academic_functioning",
          "employment_status",
          "marital_functioning",
          "marital_status",
          "social_functioning",
        ];

        try {
          const resp = await onboardingTemplate(data?.expert?.user_id);
          
          if (resp.ResponseCode === 200) {
            tabTemplates = resp?.template;
            const template = tabTemplates?.map((it) => ({
              name: dropdownData.includes(it?.name) ? "dropdown" : it?.name,
            }));
            
            // Wait for TNC check to complete before calling AppendToContext
            const tncCheckPassed = await checkTnc();
            
            if (tncCheckPassed) {
              const appendContextBody = {
                transcript: text,
                session_id: `${data?._id}`,
                appointment_id: `${data?._id}`,
                user_id: `${data?.client?.user_id}`,
                expert_id: `${data?.expert?.user_id}`,
                appointment_date: `${data?.session_date}`,
                booking_date: `${data?.session_date}`,
                ordered_fields_json: template,
              }

              //Add a snackbar which asks the user to wait while processing is done
              showProcessingSnackbar();

              const appendResponse = await AppendToContext(appendContextBody);

              // Check if response is successful (status 200 or similar success indicator)
              if (appendResponse?.status === 200 || appendResponse?.ResponseCode === 200 || (!appendResponse?.error && appendResponse?.success !== false)) {
                enqueueSnackbar(
                  "Your transcript has been submitted successfully",
                  {
                    variant: "success",
                  }
                );
                setLoading(false);
                setText("");

                // Handle successful note creation and redirect
                if (!patientData) {
                  const newURL = `/clinical/home?view=view&clinicalId=${data?._id}&noteType=${data?.session_type}`;
                  window.location.href = newURL;
                }
              } else {
                // Handle retry logic for failed requests
                if (retryCount < maxRetries) {
                  console.log(`17. RETRYING APPEND CONTEXT (${retryCount + 1}/${maxRetries}) ::: `, appendResponse)
                  enqueueSnackbar(
                    `Attempt ${retryCount + 1} failed. Retrying...`,
                    { variant: "warning" }
                  );
                  
                  // Wait 2 seconds before retry
                  setTimeout(() => {
                    processTranscript(retryCount + 1, maxRetries);
                  }, 2000);
                } else {
                  // Max retries reached
                  console.log("18. MAX RETRIES REACHED ::: ", appendResponse)
                  setLoading(false);
                  enqueueSnackbar(
                    appendResponse?.message || "Failed to submit transcript after multiple attempts. Please try again.",
                    { variant: "error" }
                  );
                }
              }
            } else {
              // TNC check failed, store pending data and let user handle TNC dialog
              setPendingAppendData({
                transcript: text,
                session_id: `${data?._id}`,
                appointment_id: `${data?._id}`,
                user_id: `${data?.client?.user_id}`,
                expert_id: `${data?.expert?.user_id}`,
                appointment_date: `${data?.session_date}`,
                booking_date: `${data?.session_date}`,
                ordered_fields_json: template,
              });
              setLoading(false);
            }
          } else {
            setLoading(false);
            enqueueSnackbar(resp?.ResponseMessage, { variant: "error" });
          }
        } catch (error) {
          setLoading(false);
          enqueueSnackbar("An error occurred while processing the transcript", { variant: "error" });
        }
      };

      // Start processing immediately
      processTranscript();
    });
  };


  const HandleDisclaimerFromAPI = async () => {
    const response = await getDisclaimer();
    const parser = new DOMParser();
    const doc = parser.parseFromString(response, "text/html");
    const contentDiv = doc.querySelector(".theme-doc-markdown.markdown");
    const encryptedEmails = contentDiv.querySelectorAll(".__cf_email__");
    encryptedEmails.forEach((element) => {
      element.innerHTML = `<a  href="mailto:${process.env.REACT_APP_CLIENT_EMAIL}">${process.env.REACT_APP_CLIENT_EMAIL}</a>`;
    });
    if (contentDiv) {
      setDisclaimercontent(contentDiv.innerHTML);
    } else {
      const fallbackMessage = `
                        Disclaimer. 
                        <a href="https://legal${getSubDomain()}/disclaimer-ccop" target="_blank">Read more</a>`;
      document.getElementById("disclaimer-content").innerText = fallbackMessage;
      setDisclaimercontent(fallbackMessage);
    }
  };
  const uploadRawText = async (text_data) => {
    const storedData = localStorage.getItem("Authorization");
    const token = storedData ? storedData?.split("Bearer ")[1] : null;
    try {
      const response = await fetch(
        `${process.env.REACT_APP_EXPERT_BASE_URL}clinicalnotes/update-raw-data`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            token: token,
            "Content-Type": "application/json",
            authenticationToken: Cookies.get("authDataJwt"),
          },
          body: JSON.stringify({
            id: `${data?._id}`,
            user_id: `${data?.client?.user_id}`,
            expert_id: `${data?.expert?.user_id}`,
            state: "In Progress",
            raw_data: text_data,
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
    } catch (error) {
      console.error("Fetching assessment list failed:", error);
      throw error;
    }
  };

  const retryAppendToContext = async () => {
    if (pendingAppendData) {
      setLoading(true);
      AppendToContext(pendingAppendData).then((res) => {
        if (res?.error) {
          setLoading(false);
          enqueueSnackbar(res?.message, { variant: "info" });
          return;
        }
        enqueueSnackbar(
          "Your transcript has been submitted successfully",
          {
            variant: "success",
          }
        );
        setLoading(false);
        setText("");
        setPendingAppendData(null);
      });
    }
  };

  const acceptTnc = async () => {
    const tnc = await acceptTNC(data?.expert?.user_id);
    if (tnc?.success) {
      fetchNotification();
      setTncDialog(false);
      // Retry the AppendToContext call after accepting TNC
      retryAppendToContext();
    } else {
      enqueueSnackbar("Error accepting T&C.", { variant: "error" });
    }
  };
  const checkTnc = async () => {
    const tnc = await getTNC(data?.expert?.user_id);
   // console.log("tnc ====>", JSON.stringify(tnc))
    if (tnc?.success) {
      if (tnc?.status) {
        // If user accepted Disclaimer check caution
        checkDisclaimer();
        return true; // TNC check passed
      } else {
        // If user not accepted Disclaimer show Disclaimer dialog
        window.localStorage.removeItem("disclaimer");
        setTncDialog(true);
        return false; // TNC check failed, dialog shown
      }
      // fetchNotification()
    } else {
      enqueueSnackbar("Error fetching disclaimer status.", {
        variant: "error",
      });
      return false; // TNC check failed due to error
    }
  };

  const fetchNotification = async () => {
    try {
      const notificationBody = {
        event: isAusDomain() ? "ccop_register_australia" : "ccop_accept_terms",
        event_metadata: {
          timestamp: dayjs().unix(),
        },
        user_id: `${data?.expert?.user_id}`,
      };
      sendNotification(JSON.stringify(notificationBody));
    } catch (error) { }
  };
  const checkDisclaimer = () => {
    const disclaimerStatus = JSON.parse(
      window.localStorage.getItem("disclaimer")
    )?.status;
    if (!disclaimerStatus) {
      // If user not accepted caution show caution dialog
      setDisclaimer(true);
    } else {
      setLoading(false);
      onSuccess();
    }
  };
  const inputRef = useRef(null);
  const focus = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  useEffect(() => {
    focus();
  }, [state]);

  const scrollChatToBottom = () => {

    const chatElement = fileRef.current;
    if (chatElement) {
      // Use setTimeout to allow DOM updates to complete before scrolling
      setTimeout(() => {
        chatElement.scrollTop = chatElement.scrollHeight;
      }, 0);
    }
  };

  const scrollChatToTop = () => {

    const chatElement = fileRef.current;
    if (chatElement) {
      // Use setTimeout to allow DOM updates to complete before scrolling
      setTimeout(() => {
        chatElement.scrollTop = 0;
        // Force a reflow to ensure the scroll happens
        chatElement.scrollTop = 0;
      }, 0);
    }
  };


  const handleHistory = async () => {
    if (!showHistory) {
      // Fetch history data when switching to history view
      setLoadingHistory(true);
      try {
        let historyList = await fetch(`https://cauth.unitedwecare.com/transcriptions/get-notes-history?note_id=${data?._id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_STELLAAPIKEY,
          },
        });
        if (!historyList.ok) {
          throw new Error("Network response was not ok");
        }
        const historyListData = await historyList.json();

        setHistoryList(historyListData);
        setShowHistory(true);
      } catch (error) {
        console.error("Error fetching history:", error);
        enqueueSnackbar("Error fetching transcription history", { variant: "error" });
      } finally {
        setLoadingHistory(false);
      }
    } else {
      // Switch back to editor view
      setShowHistory(false);
    }
  }



  return (
    <Dialog className="notetaker-new-dialog " open={open} onClose={handleClose}>
      <DialogTitle className="d-flex flex-column d-sm-none gap-2 p-2 p-lg-4 ">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h5 className="m-0 ">Voice and Document Transcriptions </h5>
          </div>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>

        <div className="d-flex flex-wrap align-items-center gap-2 gap-md-3">
          <Button
            sx={{
              borderRadius: "10px", // Rounded but not too much
              bgcolor: "var(--primary-color-opacity50)",
              color: "var(--primary-color)",
              fontSize: "14px", // 14px as in the default theme
              textTransform: "capitalize",
              "&:hover": {
                background: "var(--primary-color-opacity50)",
              },
            }}
            className="d-flex align-items-center gap-2"
            id="notetaker_upload_document_for_transcription"
            onClick={() => {
              setState(state === "editor" ? "fileupload" : "editor");
            }}
          >
            {state === "editor" ? <CloudUploadOutlined /> : <Edit />}
            {state === "editor" ? "Upload" : "Back to Editor"}
          </Button>
          {isCreate !== true && (
            <Button
              sx={{
                borderRadius: "10px",
                bgcolor: "var(--primary-color-opacity50)",
                color: "var(--primary-color)",
                fontSize: "14px",
                textTransform: "capitalize",
                "&:hover": {
                  background: "var(--primary-color-opacity50)",
                },
              }}
              className="d-flex align-items-center gap-2"
              id="notetaker_history_button"
              onClick={handleHistory}
            >
              {showHistory ? "Back to Editor" : "History"}
            </Button>
          )}
          <Button
            onClick={handleSendData}
            disabled={!(text?.trim() !== "" && data?._id)}
            sx={{
              borderRadius: "10px", // Rounded but not too much
              bgcolor: "var(--primary-color)",
              color: "white",
              fontSize: "14px", // 14px as in the default theme
              textTransform: "capitalize",
              "&:hover": {
                background: "var(--primary-color-darken)",
              },
              "&:disabled": {
                background: "var(--primary-color-opacity50)",
                color: "white",
              },
            }}
            className="d-flex align-items-center gap-2"
            id="notetaker_send_transcription"
          >
            <img
              width={24}
              src={"/assets/img/clinical_notes_assets/Frame-submit.png"}
              alt="submit"
            />
            Send Transcription
          </Button>
        </div>
      </DialogTitle>
      <DialogTitle className="d-sm-flex d-none gap-2 p-2 p-lg-4 pb-0 pb-lg-0 align-items-center  justify-content-between">
        <h5 className="m-0">Voice and Document Transcriptions</h5>
        <div
          style={{ minWidth: "455px" }}
          className="d-flex justify-content-end align-items-center  gap-2 gap-md-3"
        >
          <Button
            sx={{
              bgcolor: "var(--primary-color-opacity50)",
              color: "var(--primary-color)",
              textTransform: "capitalize",
              "&:hover": {
                background: "var(--primary-color-opacity50)",
              },
            }}
            className="PrimaryCTA---ALT"
            id="notetaker_upload_document_for_transcription"
            onClick={() => {
              setState(state === "editor" ? "fileupload" : "editor");
            }}
          >
            {state === "editor" ? <CloudUploadOutlined /> : <Edit />}
            {state === "editor" ? "Upload" : "Back to Editor"}
          </Button>
          {isCreate !== true && (
            <Button
              sx={{
                bgcolor: "var(--primary-color-opacity50)",
                color: "var(--primary-color)",
                textTransform: "capitalize",
                "&:hover": {
                  background: "var(--primary-color-opacity50)",
                },
              }}
              className="PrimaryCTA---ALT"
              id="notetaker_history_button_desktop"
              onClick={handleHistory}
            >
              {showHistory ? "Back to Editor" : "History"}
            </Button>
          )}
          <Button
            onClick={handleSendData}
            disabled={!(text?.trim() !== "")}
            className="PrimaryCTA"
            id="notetaker_send_transcription"
          >
            <img
              width={24}
              src={"/assets/img/clinical_notes_assets/Frame-submit.png"}
              alt="submit"
            />
            Send Transcription
          </Button>
          <div>
            <IconButton
              id="notetaker_close_button"
              className="  "
              onClick={handleClose}
            >
              <Close />
            </IconButton>
          </div>
        </div>{" "}
      </DialogTitle>

      <DialogContent className="p-0" ref={fileRef}>
        {state === "editor" && !showHistory && (
          <div className="mt-3">
            <div className="p-2 p-lg-4 pb-0 pb-lg-0">
              <div
                style={{
                  width: "100%",
                  boxShadow: "0px 20px 50px 0px var(--primary-color-opacity50)",
                }}
                className="rounded-top"
              >
                <textarea
                  ref={inputRef}
                  autoFocus={true}
                  placeholder="Start Typing..."
                  id="speakArea"
                  label="Speak Now"
                  style={{
                    width: "100%",
                    resize: "none",
                    border: "none",
                    maxHeight: "500px",
                    overflow: "auto",
                  }}
                  className="SpeechTextArea p-2"
                  rows={20}
                  cols={10}
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                />
                {text?.trim() !== "" && (
                  <div className="d-flex align-items-center">
                    <IconButton
                      id="notetaker_copy_text_button"
                      onClick={copyContent}
                    >
                      <ContentCopy />
                    </IconButton>
                    <IconButton
                      id="notetaker_remove_text_button"
                      onClick={() => {
                        setText("");
                        // Reset transcription status when clearing text
                        if (resetTranscriptionStatusRef.current) {
                          resetTranscriptionStatusRef.current();
                        }
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {showHistory && (
          <div className="mt-3">
            <div className="p-2 p-lg-4 pb-0 pb-lg-0">
              <div
                style={{
                  width: "100%",
                  boxShadow: "0px 20px 50px 0px var(--primary-color-opacity50)",
                  borderRadius: "12px",
                  background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                  border: "1px solid rgba(0,0,0,0.05)"
                }}
                className="rounded"
              >
                <div className="p-4">
                  <div className="d-flex align-items-center mb-4">
                    <div 
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, var(--primary-color) 0%, var(--primary-color-darken) 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "12px"
                      }}
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                        <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                      </svg>
                    </div>
                    <div>
                      <h5 className="mb-1" style={{ color: "#2c3e50", fontWeight: "600" }}>
                        Transcription History
                      </h5>
                      <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                        View and reuse your previous transcriptions
                      </p>
                    </div>
                  </div>

                  {loadingHistory ? (
                    <div className="text-center py-5">
                      <div 
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                          background: "linear-gradient(135deg, var(--primary-color-opacity50) 0%, var(--primary-color-opacity30) 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 16px"
                        }}
                      >
                        <CircularProgress size={32} sx={{ color: "var(--primary-color)" }} />
                      </div>
                      <h6 style={{ color: "#2c3e50", marginBottom: "8px" }}>Loading History</h6>
                      <p className="text-muted" style={{ fontSize: "14px" }}>
                        Please wait while we fetch your transcription history...
                      </p>
                    </div>
                  ) : historyList?.success && historyList?.data?.transcription_data?.length > 0 ? (
                    <div className="d-flex" style={{ gap: "16px", height: "calc(70vh - 200px)", maxHeight: "400px", overflow: "hidden" }}>
                      {/* Left Panel - Dates (30%) */}
                      <div 
                        style={{ 
                          width: "30%", 
                          background: "white",
                          borderRadius: "12px",
                          border: "1px solid #e9ecef",
                          overflow: "hidden",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column"
                        }}
                      >
                        <div 
                          style={{
                            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                            padding: "16px 20px",
                            borderBottom: "1px solid #e9ecef"
                          }}
                        >
                          <h6 style={{ color: "#2c3e50", fontWeight: "600", margin: 0 }}>
                            Transcriptions
                          </h6>
                          <small className="text-muted" style={{ fontSize: "12px" }}>
                            Select a transcription to view details
                          </small>
                        </div>
                        <div style={{ padding: "8px", flex: 1, overflowY: "auto", overflowX: "hidden" }}>
                          {(() => {
                            // Sort all transcriptions by creation time (newest first)
                            const sortedTranscriptions = [...historyList.data.transcription_data].sort(
                              (a, b) => new Date(b.created_at) - new Date(a.created_at)
                            );

                            // Group by date for visual separation
                            const groupedByDate = sortedTranscriptions.reduce((acc, item) => {
                              const dateKey = dayjs(item.created_at).format("YYYY-MM-DD");
                              if (!acc[dateKey]) {
                                acc[dateKey] = [];
                              }
                              acc[dateKey].push(item);
                              return acc;
                            }, {});

                            return Object.keys(groupedByDate).map((dateKey) => {
                              const dateItems = groupedByDate[dateKey];
                              const isDateSelected = selectedTranscription && dayjs(selectedTranscription.created_at).format("YYYY-MM-DD") === dateKey;
                              
                              return (
                                <div key={dateKey} style={{ marginBottom: "16px" }}>
                                  {/* Date Header */}
                                  <div 
                                    style={{
                                      padding: "8px 12px",
                                      background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                                      borderRadius: "6px",
                                      marginBottom: "8px",
                                      border: "1px solid #e9ecef"
                                    }}
                                  >
                                    <div style={{ 
                                      fontSize: "12px", 
                                      fontWeight: "600", 
                                      color: "#495057",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px"
                                    }}>
                                      {dayjs(dateKey).format("MMM DD, YYYY")} • {dayjs(dateKey).format("dddd")}
                                    </div>
                                  </div>
                                  
                                  {/* Individual Transcriptions */}
                                  {dateItems.map((item, index) => {
                                    const isSelected = selectedTranscription && selectedTranscription._id === item._id;
                                    
                                    return (
                                      <div
                                        key={item._id || index}
                                        style={{
                                          padding: "10px 12px",
                                          margin: "4px 0",
                                          borderRadius: "6px",
                                          cursor: "pointer",
                                          background: isSelected ? "var(--primary-color-opacity20)" : "white",
                                          border: isSelected ? "1px solid var(--primary-color-opacity50)" : "1px solid #e9ecef",
                                          transition: "all 0.2s ease",
                                          boxShadow: isSelected ? "0 2px 8px rgba(0,0,0,0.1)" : "0 1px 3px rgba(0,0,0,0.05)"
                                        }}
                                        onClick={() => {
                                          setSelectedTranscription(item);
                                        }}
                                        onMouseEnter={(e) => {
                                          if (!isSelected) {
                                            e.currentTarget.style.background = "#f8f9fa";
                                            e.currentTarget.style.borderColor = "#dee2e6";
                                            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
                                          }
                                        }}
                                        onMouseLeave={(e) => {
                                          if (!isSelected) {
                                            e.currentTarget.style.background = "white";
                                            e.currentTarget.style.borderColor = "#e9ecef";
                                            e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.05)";
                                          }
                                        }}
                                      >
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                          <div style={{ flex: 1 }}>
                                            <div style={{ 
                                              fontSize: "13px", 
                                              fontWeight: "600", 
                                              color: "#2c3e50",
                                              marginBottom: "2px"
                                            }}>
                                              {dayjs(item.created_at).format("h:mm A")}
                                            </div>
                                            <div style={{ 
                                              fontSize: "11px", 
                                              color: "#6c757d",
                                              lineHeight: "1.3",
                                              maxHeight: "32px",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 2,
                                              WebkitBoxOrient: "vertical"
                                            }}>
                                              {item.transcript.length > 60 ? 
                                                `${item.transcript.substring(0, 60)}...` : 
                                                item.transcript
                                              }
                                            </div>
                                          </div>
                                          <div 
                                            style={{
                                              width: "6px",
                                              height: "6px",
                                              borderRadius: "50%",
                                              background: isSelected ? "var(--primary-color)" : "#6c757d",
                                              marginLeft: "8px",
                                              flexShrink: 0
                                            }}
                                          ></div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              );
                            });
                          })()}
                        </div>
                      </div>

                      {/* Right Panel - Transcription Details (70%) */}
                      <div 
                        style={{ 
                          width: "70%", 
                          background: "white",
                          borderRadius: "12px",
                          border: "1px solid #e9ecef",
                          overflow: "hidden",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column"
                        }}
                      >
                        <div 
                          style={{
                            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                            padding: "16px 20px",
                            borderBottom: "1px solid #e9ecef"
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h6 style={{ color: "#2c3e50", fontWeight: "600", margin: 0 }}>
                                Transcription Details
                              </h6>
                              <small className="text-muted" style={{ fontSize: "12px" }}>
                                {selectedTranscription ? 
                                  `Created on ${dayjs(selectedTranscription.created_at).format("MMM DD, YYYY")} at ${dayjs(selectedTranscription.created_at).format("h:mm A")}` :
                                  "Select a date to view transcription details"
                                }
                              </small>
                            </div>
                            {selectedTranscription && (
                              <div className="d-flex gap-2">
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    navigator.clipboard.writeText(selectedTranscription.transcript);
                                    enqueueSnackbar("Text copied to clipboard!", { variant: "success" });
                                  }}
                                  style={{
                                    background: "var(--primary-color-opacity20)",
                                    color: "var(--primary-color)",
                                    transition: "all 0.2s ease"
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "var(--primary-color)";
                                    e.currentTarget.style.color = "white";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "var(--primary-color-opacity20)";
                                    e.currentTarget.style.color = "var(--primary-color)";
                                  }}
                                >
                                  <ContentCopy fontSize="small" />
                                </IconButton>
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() => {
                                    setText(selectedTranscription.transcript);
                                    setShowHistory(false);
                                    enqueueSnackbar("Transcript loaded into editor", { variant: "info" });
                                    // Use a longer timeout to ensure DOM updates are complete
                                    setTimeout(() => {
                                      scrollChatToTop();
                                    }, 100);
                                  }}
                                  style={{
                                    background: "var(--primary-color)",
                                    textTransform: "none",
                                    fontSize: "12px",
                                    padding: "6px 12px"
                                  }}
                                >
                                  Load into Editor
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                        <div style={{ padding: "20px", flex: 1, overflowY: "auto", overflowX: "hidden" }}>
                          {selectedTranscription ? (
                            <div>
                              <div 
                                style={{
                                  lineHeight: "1.6",
                                  color: "#2c3e50",
                                  fontSize: "14px",
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word"
                                }}
                              >
                                {selectedTranscription.transcript}
                              </div>
                            </div>
                          ) : (
                            <div className="text-center py-5">
                              <div 
                                style={{
                                  width: "80px",
                                  height: "80px",
                                  borderRadius: "50%",
                                  background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  margin: "0 auto 20px"
                                }}
                              >
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="#6c757d">
                                  <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                                </svg>
                              </div>
                              <h6 style={{ color: "#2c3e50", marginBottom: "8px" }}>No Transcription Selected</h6>
                              <p className="text-muted" style={{ fontSize: "14px", maxWidth: "300px", margin: "0 auto" }}>
                                Click on a transcription from the left panel to view the full details here.
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <div 
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "50%",
                          background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 20px"
                        }}
                      >
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="#6c757d">
                          <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                        </svg>
                      </div>
                      <h6 style={{ color: "#2c3e50", marginBottom: "8px" }}>No History Found</h6>
                      <p className="text-muted" style={{ fontSize: "14px", maxWidth: "300px", margin: "0 auto" }}>
                        You haven't created any transcriptions yet. Start by typing or uploading a document to see your history here.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {!showHistory && (
          <>
            <div className="px-2 px-lg-4">
              {/* <AudioVisualizer
                transcription={(data) => {
                  
                  setText((prev) => prev + " " + data);
                  // scrollChatToTop();
                }}
                state={state}
                scrollOnChange={scrollChatToBottom}
              /> */}
              <NewAudioVisualizer
                transcription={(data) => {
                  setText((prev) => prev + " " + data);
                  // Scroll to top to show the response after transcription completes
                  scrollChatToTop();
                }}
                state={state}
                data={data}
                clientDetails={clientDetails}
                responseData={responseData}
                patientData={patientData}
                isCreate={isCreate}
                setTranscriptionLink={setTranscriptionLink}
                setApiUsed={setApiUsed}
              />
            </div>

            <FileUploaderModal
              data={data}
              transcription={(data) => {
                setText(text + " " + data);
                setState("editor");
                // Scroll to top to show the response after file transcription completes
                scrollChatToTop();
              }}
              state={state}
              scrollOnChange={scrollChatToBottom}
              onResetTranscriptionStatus={resetTranscriptionStatusRef}
              clientDetails={clientDetails}
              responseData={responseData}
              patientData={patientData}
              isCreate={isCreate}
            />
          </>
        )}
        <DisclaimerModal
          disclaimer={disclaimer}
          close={() => setDisclaimer(true)}
          handleAccept={async () => {
            window.localStorage.setItem(
              "disclaimer",
              JSON.stringify({ status: true })
            );

            // Track clinical note accept caution event (only when creating new note)
            if (isCreate === true) {
              try {
                const profileData = JSON.parse(localStorage.getItem("profile"));
                const userId = profileData?.UserId;
                const patientId = clientDetails?.user_id || responseData?.user_id || patientData?.user_id || data?.client?.user_id;
                const noteId = data?._id;
                
                if (userId && patientId && noteId) {
                  await trackClinicalNoteAcceptCaution(
                    userId,
                    patientId,
                    noteId
                  );
                }
              } catch (trackingError) {
                console.error("Error tracking accept caution event:", trackingError);
                // Don't block process if tracking fails
              }
            }

            setDisclaimer(false);
            setLoading(false);
            onSuccess();
          }}
        />
        <AcceptCCOPDisclaimer
          open={tncDialog}
          close={() => setTncDialog(true)}
          disclaimercontent={disclaimercontent}
          handleAccept={() => {
            acceptTnc();
          }}
        />
        <Backdrop
          sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
          open={loading}
        >
          <img
            alt=""
            src="/assets/img/icons/aisparkle.png"
            width={50}
            className="animate-pulse"
          />
        </Backdrop>
      </DialogContent>
    </Dialog>
  );
}

export default NewTranscriptionDialog;
